/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bankingregistry": {
        "nested": {
          "plaid": {
            "nested": {
              "Application": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "logoUrl": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "applicationUrl": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "reasonForAccess": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "displayName": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bankingregistry?.nested?.plaid?.nested?.Application) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A Plaid application
 * --
 *
 * SOURCE Application @ squareup/bankingregistry/plaid/model.proto at 9:1
 */
export const Application = $root.lookupType('squareup.bankingregistry.plaid.Application');
fixType(Application);
Builder.createAndAttachToType(Application);